import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CarouselBlockConfig } from '@front-platform/content-builder';
import { carouselBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { carouselBlockHostLayoutClasses } from './carousel-layout';
export interface CarouselBlockRuntimeConfig {
  'slides'?: unknown[] | undefined;
}

export type CarouselBlockConfigInput = Partial<
  Omit<CarouselBlockConfig, keyof CarouselBlockRuntimeConfig> & CarouselBlockRuntimeConfig
>;
export type CarouselBlockResolvedConfig = Omit<
  CarouselBlockConfig,
  keyof CarouselBlockRuntimeConfig
> &
  Partial<CarouselBlockRuntimeConfig>;
export interface CarouselBlockContract extends ConfigComponentContract<
  CarouselBlockConfigInput,
  CarouselBlockResolvedConfig
> {}

@Component({
  selector: 'app-carousel-block',
  templateUrl: './carousel-block.component.html',
  host: {
    '[class]': 'hostLayoutClasses',
  },
  standalone: false,
})
export class CarouselBlockComponent implements CarouselBlockContract {
  readonly config = input<CarouselBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<CarouselBlockConfig, CarouselBlockRuntimeConfig>(
    carouselBlockResolveConfig,
    () => ({ config: this.config() }),
  );
  get slides(): unknown[] | undefined {
    return this.resolvedConfig()['slides'] as unknown as unknown[] | undefined;
  }
  get positionSticky(): boolean {
    return this.resolvedConfig()['position_sticky'] as unknown as boolean;
  }
  get positionStickyTop(): number {
    return this.resolvedConfig()['position_sticky_top'] as unknown as number;
  }
  get backgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor;
  }
  get layout(): string {
    return this.resolvedConfig()['layout'] as unknown as string;
  }
  get hostLayoutClasses(): string {
    return carouselBlockHostLayoutClasses(this.layout);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CarouselBlockComponent, { 'keyAliases': {} });
